import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Injectable,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { NgPatientModule } from '@principle-theorem/ng-patient';
import {
  PatientProfileSummaryWorkflowDialogService,
  type PatientProfileSummaryWorkflowSection,
} from '@principle-theorem/ng-principle-shared';
import { DialogPresets, NgDialogModule } from '@principle-theorem/ng-shared';
import { type IPatient } from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';

export interface IPatientProfileSummaryWorkflowDialogData {
  patient: WithRef<IPatient>;
  section: PatientProfileSummaryWorkflowSection;
}

@Component({
  selector: 'pr-patient-profile-summary-workflow-dialog',
  imports: [NgDialogModule, NgPatientModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './patient-profile-summary-workflow-dialog.component.html',
})
export class PatientProfileSummaryWorkflowDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: IPatientProfileSummaryWorkflowDialogData
  ) {}
}

@Injectable()
export class AppointmentPatientProfileSummaryWorkflowDialogService extends PatientProfileSummaryWorkflowDialogService {
  constructor(private _dialog: MatDialog) {
    super();
  }

  override open(
    patient: WithRef<IPatient>,
    section: PatientProfileSummaryWorkflowSection
  ): void {
    this._dialog.open(
      PatientProfileSummaryWorkflowDialogComponent,
      DialogPresets.large({
        data: { patient, section },
      })
    );
  }
}
